'use strict';

angular.module('myConsultApp')
    .factory('UploadReceiptService', function (Upload, $resource, ENV, Session) {

      var uploadReceiptService = {};
      
      var user;
      var pet;

      uploadReceiptService.getClientInfo = function(str) {

        var owners = $resource(ENV.apiEndpoint + '/1.0/user-search/',{},{
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return owners.get({ search: str, applications: 'Loyalty application' }).$promise.then(function(response) {
          return response;
        });

      };
      
      uploadReceiptService.getClientInfoPage = function(str) {
        var owners = $resource(str,{},{
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return owners.get().$promise.then(function(response) {
          return response;
        });

      };

      uploadReceiptService.getAllProducts = function() {

        var products = $resource(ENV.apiEndpoint + '/1.0/products/',{},{
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return products.get().$promise.then(function(response) {
          return response;
        });

      };

      uploadReceiptService.getOrgProducts = function(orgs) {
        var products = $resource(ENV.apiEndpoint + '/1.0/products/?organizations=' + orgs, {}, {
          get:{
            headers: { 'Authorization': 'Bearer '+Session.accessToken }
          }
        });

        return products.get().$promise.then(function(response) {
          return response;
        });

      };
      

      uploadReceiptService.uploadReceipt = function(file, id) {

        return Upload.upload({
          url: ENV.apiEndpoint + '/1.0/receipts/',
          data: {
            image: file,
            user_id: id
          },
          headers: { 'Authorization': 'Bearer '+Session.accessToken},
          disableProgress: false
        });

      };

      uploadReceiptService.submitTransaction = function(paramObj) {

        var transaction = $resource(ENV.apiEndpoint + '/1.0/transactions/'+ paramObj.transaction_id +'/',{}, {
          save:{
            method: 'PUT',
            headers: { 'Authorization': 'Bearer '+Session.accessToken, 'Content-Type': 'application/json' }
          }
        });

        return transaction.save(paramObj.recepit_data).$promise.then(function(response) {
          return response;
        });

      };
      
      uploadReceiptService.storeData = function (uservalue, petvalue) {
					user = uservalue;
					pet = petvalue;
          return user;
      };
      
      uploadReceiptService.getData = function () {
	      	var data = {user : user, pet : pet};
	      	user = '';
	      	pet = '';
          return data;
      };

      return uploadReceiptService;

    });